<template>

  <div>

    <b-card-title class="ml-4 mb-3">{{ name }}</b-card-title>

    <t-page-form-field-customizable
        v-model="form.fieldCustomizable" :command="command" :status="status"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.pageFieldId" :foreign-key="form.pageId"
        :items="items" :user-auth="userAuth"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :error-field="error_fieldCustomizable" :general-errors="generalErrors"
        @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault"
        @onCancelUpdatedList="cancelUpdatedField" @onRequestList="getList">

      <template #form-header>

        <b-form-checkbox class="col-sm-6 col-md-6 ml-3" v-if="enableNote" v-model="form.enableNote" switch>
          <small>Adicionar campo de observações?</small>
          <t-help
              title="Sendo ativado irá adicionar um campo de observações para preenchimento"/>
        </b-form-checkbox>

      </template>

    </t-page-form-field-customizable>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormFieldMixin from "@/mixins/page/pageFormFieldMixin";


import tPageFormFieldCustomizable from "@/components/template/page/t-page-form-field-customizable";
import FieldCustomizableEntity from "@/model/entities/resource/entity/FieldCustomizableEntity";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormFieldMixin],
  components: {tPageFormFieldCustomizable},
  name: 'PageField',
  data() {
    return {
      path: "setting/page-field", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "pageFieldId",
      foreignKeyColumn: "pageId", //Utilizar quando usar Tabs com outros componentes
      form: {
        pageId: this.foreignKey,
        pageFieldId: 0,
        enableNote: false,
        fieldCustomizable: new FieldCustomizableEntity(),
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      error: {//Campos que podem receber retorno de erro do backend

      },

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    pageId: Number,
    typeImage: Boolean,
    name: String,
    enableNote: Boolean,
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormField()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {



      await this.getList()

    },

    async onSubmit() {

      this.path += "?pageId=" + this.foreignKey

      await  this.setSending(
          this.form.pageFieldId,
          () => {
            this.path = "setting/page-field"
            this.actionDefaultAfterCRUD()
          },
          () => {
            this.path = "setting/page-field"
            this.actionDefaultAfterCRUD()
          }, () => {
            this.path = "setting/page-field"
            this.actionDefaultAfterCRUD()
          },
      )

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------


      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
